import React, { useEffect, useState } from 'react';
import ApiContext from './Components/globalStore/ApiContext';
import { SearchProvider } from './Components/globalStore/SearchContext';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Styles/App.css';
import './Styles/style.css';
import './Styles/responsive.css';
import ApiRoutes from './Routes/ApiRoutes';
import '@fontsource/orbitron/400.css'; /* Regular */
import '@fontsource/orbitron/700.css'; /* Bold */
import { DataProvider } from './Context/DataProvider';
import { Spin } from 'antd';

export default function App() {
  const [apiData, setApiData] = useState([]);
  const token = localStorage.getItem("userId");
  const [loading, setLoading] = useState(true); // <---- this can all be replace by react query in the future

  // it is very good idea to seperate out this fetching of user data to an AuthProvider
  useEffect(() => {
    if (token) {
      fetch("https://backproject.meanc.net/meanc/users/", {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Token ${token}`,
        },
      })
        .then(response => response.json())
        .then(da => {
          setApiData(da);
          console.log("Here User data from App:", da);
        })
        .catch(error => {
          console.log("here an error:", error);
        })
        .finally(() => setLoading(false));
    }else {
      setLoading(false);
    }
  }, [token]);

  if(loading){
    return null;
  }

  return (
    <DataProvider>
      <ApiContext.Provider value={{ apiData, setApiData }}>
        <SearchProvider>
          <ApiRoutes />
        </SearchProvider>
      </ApiContext.Provider>
    </DataProvider>
  );
}
